import {MoreVerticalIcon, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import * as classes from './AdvertBadge.classes'

type Props = {
  text?: string
}

export const AdvertBadge: React.FC<Props> = ({text}) => {
  return (
    <div className={classes.root}>
      <Typography className={classes.text} variant="caption2">
        {text}
      </Typography>
      <MoreVerticalIcon className={classes.icon} />
    </div>
  )
}
